import {
    CircularProgress,
    Dialog,
    DialogContent,
    DialogTitle,
    Divider,
    Typography,
} from "@material-ui/core"
import { useEffect, useState } from "react"
import { buscarHistoricoPedido } from "../../services/integracao"

// A dataHora vem de um Calendar serializado — pode chegar como número (ms),
// string ISO, ou objeto com timeInMillis. Formata defensivamente.
function formatarDataHora(valor) {
    try {
        let d
        if (valor == null) return ""
        if (typeof valor === "number") d = new Date(valor)
        else if (typeof valor === "string") d = new Date(valor)
        else if (typeof valor === "object" && valor.timeInMillis) d = new Date(valor.timeInMillis)
        else if (typeof valor === "object" && valor.time) d = new Date(valor.time)
        else return ""
        if (isNaN(d.getTime())) return ""
        return d.toLocaleString("pt-BR")
    } catch {
        return ""
    }
}

function nomeResponsavel(responsavel) {
    if (!responsavel) return ""
    if (typeof responsavel === "string") return responsavel
    return responsavel.nome || responsavel.nomeFantasia || ""
}

/**
 * Diálogo de histórico do pedido. A consulta ao endpoint só acontece quando o
 * diálogo abre (lazy), conforme requisito.
 */
export default function DialogHistoricoPedido({ aberto, pedidoId, autorizacao, onClose }) {
    const [loading, setLoading] = useState(false)
    const [erro, setErro] = useState("")
    const [historico, setHistorico] = useState([])

    useEffect(() => {
        if (!aberto || !pedidoId) return
        let cancelado = false
        setLoading(true)
        setErro("")
        setHistorico([])
        buscarHistoricoPedido(pedidoId, autorizacao).then(resp => {
            if (cancelado) return
            setLoading(false)
            if (resp.retornoErro) {
                setErro(resp.mensagem || "Não foi possível carregar o histórico.")
                return
            }
            setHistorico(resp.historico || [])
        })
        return () => {
            cancelado = true
        }
    }, [aberto, pedidoId, autorizacao])

    return (
        <Dialog open={!!aberto} onClose={onClose} maxWidth="sm" fullWidth>
            <DialogTitle>Histórico do pedido #{pedidoId}</DialogTitle>
            <DialogContent dividers>
                {loading && (
                    <div style={{ textAlign: "center", padding: 24 }}>
                        <CircularProgress size={28} />
                    </div>
                )}
                {!loading && erro && (
                    <Typography color="error" variant="body2">
                        {erro}
                    </Typography>
                )}
                {!loading && !erro && historico.length === 0 && (
                    <Typography variant="body2" color="textSecondary">
                        Sem registros de histórico para este pedido.
                    </Typography>
                )}
                {!loading &&
                    !erro &&
                    historico.map((h, i) => (
                        <div key={h.id || i} style={{ marginBottom: 12 }}>
                            <Typography variant="subtitle2" style={{ fontWeight: 600 }}>
                                {h.acao || "—"}
                            </Typography>
                            <Typography variant="caption" color="textSecondary">
                                {formatarDataHora(h.dataHora)}
                                {nomeResponsavel(h.responsavel)
                                    ? ` • ${nomeResponsavel(h.responsavel)}`
                                    : ""}
                            </Typography>
                            {h.descricao && (
                                <Typography variant="body2" style={{ marginTop: 2 }}>
                                    {h.descricao}
                                </Typography>
                            )}
                            {i < historico.length - 1 && <Divider style={{ marginTop: 8 }} />}
                        </div>
                    ))}
            </DialogContent>
        </Dialog>
    )
}
